export default [
    {
        path: 'relatorio-consumo-medio-mensal',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-relatorio-consumo-medio-mensal' */
            '@/views/almoxarifado/relatorio-consumo-medio-mensal/Index'
        ),
        redirect: 'relatorio-consumo-medio-mensal/index',
        children: [
            {
                name: 'almoxarifado-relatorio-consumo-medio-mensal-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-relatorio-consumo-medio-mensal' */
                    '@/views/almoxarifado/relatorio-consumo-medio-mensal/List.vue'
                ),
            },
        ],
    },
]